'use client';

import { MenuItemType, MenuType } from '@vimond/services/content-discovery';
import { useAppContent } from './useAppContent';

type Props = {
  alias?: string;
  locale: string;
};
export const useMainMenu = ({ alias, locale }: Props) => {
  const { content, isLoading, error } = useAppContent({ alias, locale });
  const header = content?.elements?.find((e) => {
    if (e.contentType === 'menu') {
      const menu = e;
      return menu['layout-menu-position'] === 'Header';
    }
    return false;
  }) as MenuType | undefined;
  const logo = header?.elements?.find((item) => item.images?.defaultUrl) as
    | MenuItemType
    | undefined;
  const menu = ((logo
    ? header?.elements?.slice(1).filter((m) => m.contentType === 'menu_item')
    : header?.elements) ?? []) as MenuItemType[] | undefined;

  // TODO: handle external links // right side menu links
  return {
    header,
    logo,
    menu,
    error,
    isLoading,
  };
};
